var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-graduation-cap","titulo":"BASE DE CONHECIMENTO","mostrarQtd":false,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'BaseConhecimento' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }